/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { LoginOptions, LoginResponses } from '../../models/Login'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Authenticate a user using username and password.
 * @summary Login
 * {@link /login}
 */
export function login<ThrowOnError extends boolean = true>(options: Options<LoginOptions, ThrowOnError>): Promise<UnwrappedResult<LoginResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/login', contentType: { request: 'application/x-www-form-urlencoded' }, ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<LoginResponses, ThrowOnError>>
}
